module.exports = __webpack_public_path__ + "media/promo/courses/images/format1-3b6e68bd587b623a1853e4b8f94e1f65.png";